import { ApiVendorSchema } from 'api/types/report/api/vendor';
import { z } from 'zod';

import { ApiDashboardTableDataResultSchema } from './dataResult';

export const ApiDashboardTableDataSchema = z.object({
  result: ApiDashboardTableDataResultSchema,
  vendor: ApiVendorSchema,
});
